import React, { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ValidatedTextField from '../../inputs/ValidatedTextField';
import ValidatedCardInput from '../../inputs/ValidatedCardInput';

import visaLogo from '../../../assets/cardBrands/visa.svg';
import mastercardLogo from '../../../assets/cardBrands/mastercard.svg';
import amexLogo from '../../../assets/cardBrands/amex.svg';
import discoverLogo from '../../../assets/cardBrands/discover.svg';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const PaymentInfo = forwardRef(
	({ formData, errors, handleInputChange, handleInputBlur }, ref) => {
		const { t } = useTranslation('paymentInfo');

		useImperativeHandle(ref, () => ({
			clearFields: () => {
				const cardFields = ['cardNumber', 'expiryDate', 'cvc'];
				cardFields.forEach((name) => {
					const input = document.querySelector(`input[name="${name}"]`);
					if (input) input.value = '';
				});
			}
		}));

		const CardBrandIcons = () => (
			<Stack direction='row' spacing={1} sx={{ ml: 1.5 }}>
				<Box
					component='img'
					src={visaLogo}
					alt='Visa'
					sx={{ height: 24, borderRadius: 1 }}
				/>
				<Box
					component='img'
					src={mastercardLogo}
					alt='Mastercard'
					sx={{ height: 24, borderRadius: 1 }}
				/>
				<Box
					component='img'
					src={amexLogo}
					alt='Amex'
					sx={{ height: 24, borderRadius: 1 }}
				/>
				<Box
					component='img'
					src={discoverLogo}
					alt='Discover'
					sx={{ height: 24, borderRadius: 1 }}
				/>
			</Stack>
		);

		return (
			<Box>
				<Stack
					direction='row'
					alignItems='center'
					justifyContent='space-between'
					mb={2}
				>
					<Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
						{t('creditCard')}
					</Typography>
					<CardBrandIcons />
				</Stack>

				<Stack spacing={2}>
					<ValidatedCardInput
						errors={errors}
						handleInputChange={handleInputChange}
						handleInputBlur={handleInputBlur}
					/>

					<ValidatedTextField
						name='billingZip'
						label={t('billingZip')}
						formData={formData}
						handleInputChange={handleInputChange}
						handleInputBlur={handleInputBlur}
						required
						errors={errors}
						inputMode='numeric'
					/>
				</Stack>
			</Box>
		);
	}
);

PaymentInfo.propTypes = {
	formData: PropTypes.object,
	errors: PropTypes.object,
	handleInputChange: PropTypes.func,
	handleInputBlur: PropTypes.func
};

export default PaymentInfo;
